import store from '@/store';

/**
 * 判断业务逻辑码
 * @param {number} code 
 */
export const isValidCode = (code) => {
  const c = parseInt(code, 10);
  return (!Number.isNaN(c)) && (c < 20000);
};

/**
 * 获得根据 getGlobalConfig 接口的返回值对业务逻辑错误对应通用的提示
 * @param {string} reqStr - 错误发生时的接口请求 URL，格式为 `${method} ${url}`
 * @param {Object} json - 返回的 {errno, errmsg, data} 对象
 */
export const getErrorTip = (reqStr, json) => {
  // eslint-disable-next-line no-unused-vars
  const [method, url] = reqStr.split(/\s/);

  const errno = parseInt(json.errno, 10);
  const isValid = isValidCode(errno);
  const globalData = store.state.global.data;
  
  let _msg = null;
  // 根据 getGlobalConfig 接口获得的返回值
  // 表示与 errno 和请求 url 相关的 tips 提示
  // 没配置的情况下，提示errmsg的内容
  if (globalData && globalData.tips) {
    const { tips } = globalData;
    const tipsOfErr = tips[errno];
    
    if (tipsOfErr) {
      _msg = reqStr in tipsOfErr
        ? tipsOfErr[reqStr]
        : url in tipsOfErr
          ? tipsOfErr[url]
          : 'default' in tipsOfErr
            ? tipsOfErr.default
            : isValid
              ? null
              : json.errmsg;
    } else if (!isValid) {
      _msg = json.errmsg;
    }
  }
  return _msg;
};



// WEBPACK FOOTER //
// ./src/axiosHandler/busi.utils.js